import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import lodash from "lodash"
// import pattern from "pattern.css"
import AOS from "aos";
import "aos/dist/aos.css";
import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo);

Vue.config.productionTip = false;

new Vue({
    created() {
        AOS.init({ disable: false });
    },
    router,
    render: h => h(App)
}).$mount("#app");
